import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';
//Importo o componente de conteudo
import './Components/Miscelania/Globals';
//Importo as views

// Calendario
import Calendar from './Components/Calendar/Calendar';

// Staffs
import StaffsIndex from './Components/Staffs/StaffsIndex';
import StaffsEdit from './Components/Staffs/StaffsEdit';
import StaffsAdd from './Components/Staffs/StaffsAdd';
import StaffsInstrutores from './Components/Staffs/StaffsInstrutores';

// Employers
import EmployersIndex from './Components/Employers/EmployersIndex';
import EmployersEdit from './Components/Employers/EmployersEdit';
import EmployersAdd from './Components/Employers/EmployersAdd';

// Trainings
import TrainingsIndex from './Components/Trainings/TrainingsIndex';
import TrainingsEdit from './Components/Trainings/TrainingsEdit';
import TrainingsAdd from './Components/Trainings/TrainingsAdd';

// Materials
import MaterialsIndex from './Components/Materials/MaterialsIndex';
import MaterialsEdit from './Components/Materials/MaterialsEdit';
import MaterialsAdd from './Components/Materials/MaterialsAdd';

// Cadastro Geral
import RolesIndex from './Components/Cadastro/RolesIndex';
import TargetsIndex from './Components/Cadastro/TargetsIndex';
import TargetEdit from './Components/Cadastro/TargetEdit';
import RoleEdit from './Components/Cadastro/RoleEdit';
import PdfsIndex from './Components/Cadastro/PdfsIndex';

// AircraftModels
import AircraftModelsIndex from './Components/AircraftModels/AircraftModelsIndex';
import AircraftModelsEdit from './Components/AircraftModels/AircraftModelsEdit';
import AircraftModelsAdd from './Components/AircraftModels/AircraftModelsAdd';

// Emails
import EmailsIndex from './Components/Emails/EmailsIndex';
import EmailsEdit from './Components/Emails/EmailsEdit';

// Categories
import CategoriesIndex from './Components/Categories/CategoriesIndex';
import CategoriesEdit from './Components/Categories/CategoriesEdit';
import CategoriesAdd from './Components/Categories/CategoriesAdd';

// Matters
import MattersIndex from './Components/Matters/MattersIndex';
import MattersIndexArchived from './Components/Matters/MattersIndexArchived';
import MattersEdit from './Components/Matters/MattersEdit';
import MattersAdd from './Components/Matters/MattersAdd';
import CertificationMatters from './Components/Matters/CertificationMatters';
import CertificationsSigtrip from './Components/Matters/CertificationsSigtrip';
import CertificationsSigmec from './Components/Matters/CertificationsSigmec';

// Questions
import QuestionsIndex from './Components/Questions/QuestionsIndex';
import QuestionsEdit from './Components/Questions/QuestionsEdit';
import QuestionsAdd from './Components/Questions/QuestionsAdd';

// Teams
import TeamsIndex from './Components/Teams/TeamsIndex';
import TeamsSigtripUnread from './Components/Teams/TeamsSigtripUnread';
import TeamsSigtripRead from './Components/Teams/TeamsSigtripRead';
import TeamsSigmecUnread from './Components/Teams/TeamsSigmecUnread';
import TeamsSigmecRead from './Components/Teams/TeamsSigmecRead';
import TeamsClosed from './Components/Teams/TeamsClosed';
import TeamsEdit from './Components/Teams/TeamsEdit';
import TeamsAdd from './Components/Teams/TeamsAdd';
import TrainingJobFailsIndex from './Components/Teams/TrainingJobFailsIndex';
import MoodleMissionPeriodsIndex from './Components/Teams/MoodleMissionPeriodsIndex';
import MoodleCourseCompletionSnapshotsIndex from './Components/Moodle/MoodleCourseCompletionSnapshotsIndex';

// TeamTasks
import TeamTasksIndex from './Components/TeamTasks/TeamTasksIndex';

// Exams
import ExamsIndex from './Components/Exams/ExamsIndex';
//import ExamsIndexOpened from './Components/Exams/ExamsIndexOpened';
//import ExamsIndexClosed from './Components/Exams/ExamsIndexClosed';
import ExamsIndexUnrelated from './Components/Exams/ExamsIndexUnrelated';
import ExamsIndexArchived from './Components/Exams/ExamsIndexArchived';
import ExamsEdit from './Components/Exams/ExamsEdit';
import ExamsAdd from './Components/Exams/ExamsAdd';
import ExamsUnrelatedAdd from './Components/Exams/ExamsUnrelatedAdd';

// Settings
import ImportIndex from './Components/Imports/ImportIndex';

// Users
import Login from './Components/Users/Login';
import RecuperarSenha from './Components/Users/RecuperarSenha';
import Suspenso from './Components/Users/Suspenso';
import UsersEditPassword from './Components/Users/UsersEditPassword';
import UsersEdit from './Components/Users/UsersEdit';
import UsersIndex from './Components/Users/UsersIndex';
import UsersStaffIndex from './Components/Users/UsersStaffIndex';
import UsersAdd from './Components/Users/UsersAdd';

// Configuracoes
import ConfiguracoesQuestoesDificuldade from './Components/Configuracoes/ConfiguracoesQuestoesDificuldade';
import ConfiguracoesProvasDificuldade from './Components/Configuracoes/ConfiguracoesProvasDificuldade';
import ConfiguracoesEdit from './Components/Configuracoes/ConfiguracoesEdit';
import ConfiguracoesMoodleEdit from './Components/Configuracoes/ConfiguracoesMoodleEdit';
import ShortNameDescriptions from './Components/Configuracoes/ShortNameDescriptions';

class App extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      permission: false,
    }

  }
    componentDidMount() {
        var url_login = config.get('url') + '/usuario/login';
        var url_suspended = config.get('url') + '/usuario/suspenso';
        var url_recovery_pw = config.get('url') + '/usuario/recuperar_senha';
        var url_actual = window.location.href;

        if(url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw) {
          // busco as infos
          var params = JSON.parse(localStorage.getItem("cid"));
          // Verifico se há algum storage setado
          if(params === null || typeof params === 'undefined') {
            window.location.replace(config.get('url') + '/usuario/login');
          } else {
            // Verifico se o cid acode setado
            if(params.acode === null || typeof params.acode === 'undefined') {
              window.location.replace(config.get('url') + '/usuario/login');
            } else {
              this.setState({permission: true});
            }
          }
        } else {
          this.setState({permission: true});
        }
    }
  render() {
    return (
      <div>
        {
            (this.state.permission === false) ? '' :
              <div>
                <BrowserRouter>
                  <Switch>
                    {/* Usuários */}
                    <Route path="/usuario/login" component={Login} />
                    <Route path="/usuario/suspenso" component={Suspenso} />
                    {/* Alunos */}
                    <Route path="/aluno/cadastrar" component={StaffsAdd} />
                    <Route path="/aluno/editar/:id" component={StaffsEdit} />
                    <Route path="/alunos" component={StaffsIndex} />
                    <Route path="/instrutores" component={StaffsInstrutores} />
                    {/* Empregadores */}
                    <Route path="/empregador/cadastrar" component={EmployersAdd} />
                    <Route path="/empregador/editar/:id" component={EmployersEdit} />
                    <Route path="/empregadores" component={EmployersIndex} />

                    {/* Importações */}
                    <Route path="/importar" component={ImportIndex} />
                    
                    {/* Frotas */}
                    <Route path="/frota/cadastrar" component={AircraftModelsAdd} />
                    <Route path="/frota/editar/:id" component={AircraftModelsEdit} />
                    <Route path="/frotas" component={AircraftModelsIndex} />

                    {/* Emails */}
                    <Route path="/email/editar/:id" component={EmailsEdit} />
                    <Route path="/emails" component={EmailsIndex} />

                    {/* Categorias */}
                    <Route path="/categoria/cadastrar" component={CategoriesAdd} />
                    <Route path="/categoria/editar/:id" component={CategoriesEdit} />
                    <Route path="/categorias" component={CategoriesIndex} />

                    {/* Matérias */}
                    <Route path="/materia/cadastrar" component={MattersAdd} />
                    <Route path="/materia/editar/:id" component={MattersEdit} />
                    <Route path="/materias/arquivadas" component={MattersIndexArchived} />
                    <Route path="/materias" component={MattersIndex} />

                    <Route path="/certificados/materias" component={CertificationMatters} />
                    <Route path="/certificados/sigtrip" component={CertificationsSigtrip} />
                    <Route path="/certificados/sigmec" component={CertificationsSigmec} />

                    {/* Treinamentos */}
                    <Route path="/treinamento/cadastrar" component={TrainingsAdd} />
                    <Route path="/treinamento/editar/:id" component={TrainingsEdit} />
                    <Route path="/treinamentos" component={TrainingsIndex} />

                    {/* Configurações - Posicionamento obrigatório - NÂO RETIRAR */}
                    <Route path="/questoes/dificuldades" component={ConfiguracoesQuestoesDificuldade} />

                    {/* Questões */}
                    <Route path="/questao/cadastrar" component={QuestionsAdd} />
                    <Route path="/questao/editar/:id" component={QuestionsEdit} />
                    <Route path="/questoes" component={QuestionsIndex} />

                    {/* Materiais */}
                    <Route path="/material/cadastrar" component={MaterialsAdd} />
                    <Route path="/material/editar/:id" component={MaterialsEdit} />
                    <Route path="/materiais" component={MaterialsIndex} />

                    {/* Tarefas */}
                    <Route path="/turmas/tarefas" component={TeamTasksIndex} />

                    {/* Turmas */}
                    <Route path="/turma/cadastrar" component={TeamsAdd} />
                    <Route path="/turma/editar/:id" component={TeamsEdit} />
                    <Route path="/turmas/canceladas" component={TeamsClosed} />
                    <Route path="/turmas/erros/integracao" component={TrainingJobFailsIndex} />
                    <Route path="/moodle/periodos/missao" component={MoodleMissionPeriodsIndex} />
                    <Route path="/moodle/conclusoes-pendentes" component={MoodleCourseCompletionSnapshotsIndex} />
                    <Route path="/turmas" component={TeamsIndex} />
                    <Route path="/sigtrip/comunicados/nao/lidos" component={TeamsSigtripUnread} />
                    <Route path="/sigtrip/comunicados/lidos" component={TeamsSigtripRead} />
                    <Route path="/sigmec/comunicados/nao/lidos" component={TeamsSigmecUnread} />
                    <Route path="/sigmec/comunicados/lidos" component={TeamsSigmecRead} />

                    {/* Provas */}
                    <Route path="/prova/cadastrar" component={ExamsAdd} />
                    <Route path="/prova/nao/relacionada" component={ExamsUnrelatedAdd} />
                    <Route path="/prova/editar/:id" component={ExamsEdit} />
                    <Route path="/provas/arquivadas/listagem" component={ExamsIndexArchived} />
                    <Route path="/provas/listagem" component={ExamsIndex} />
                    <Route path="/provas/nao/relacionadas/listagem" component={ExamsIndexUnrelated} />

                    {/*<Route path="/provas/abertas/listagem" component={ExamsIndexOpened} />}
                    <Route path="/provas/fechadas/listagem" component={ExamsIndexClosed} />
                    <Route path="/provas/arquivadas/listagem" component={ExamsIndexArchived} />*/}

                    {/* Público-alvo e funções */}
                    <Route path="/publico_alvo" component={TargetsIndex} />
                    <Route path="/publico/alvo/editar/:id" component={TargetEdit} />
                    <Route path="/funcoes" component={RolesIndex} />
                    <Route path="/funcao/editar/:id" component={RoleEdit} />

                    {/* Configurações */}
                    <Route path="/questoes/dificuldades" component={ConfiguracoesQuestoesDificuldade} />
                    <Route path="/provas/dificuldades" component={ConfiguracoesProvasDificuldade} />

                    <Route path="/config/moodle" component={ConfiguracoesMoodleEdit} />
                    <Route path="/configuracoes" component={ConfiguracoesEdit} />
                    <Route path="/pdf" component={PdfsIndex} />
                    <Route path="/descricao/nomes/curtos" component={ShortNameDescriptions} />

                    {/* User*/}
                    <Route path="/usuario/editar/:id" component={UsersEdit} />
                    <Route path="/usuarios/alunos" component={UsersStaffIndex} />
                    <Route path="/usuarios" component={UsersIndex} />

                    {/* Calendario */}
                    <Route path="/calendario" component={Calendar} />
                    <Route path="/" component={Calendar} />
                  </Switch>
                </BrowserRouter>
              </div>

        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js